import React from 'react';
import {Routes,Route,Navigate} from 'react-router-dom';
import Home from './pages/Home';
import GamePlay from './pages/GamePlay';
import Results from './pages/Results';
import About from './pages/About';

function App() {
  return (
    <div className="min-h-screen w-full bg-gradient-to-br from-pink-100 via-purple-100 to-blue-100">
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/play" element={<GamePlay />} />
        <Route path="/results" element={<Results />} />
        <Route path="/about" element={<About />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </div>
  );
}

export default App;